// extracted by mini-css-extract-plugin
export default {"container":"VersionSummary_container__ap6ol"};